import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

const CATEGORY_COUNT = 4;
const ITEMS_PER_CATEGORY = 6;

export const CategorySettingsSkeleton = () => (
  <Box sx={{ maxWidth: 720, mx: "auto", p: 2 }}>
    <Skeleton variant="text" width={200} height={24} sx={{ mb: 1 }} />
    <Skeleton variant="text" width={220} height={36} sx={{ mb: 2 }} />
    {Array.from({ length: CATEGORY_COUNT }).map((_, ci) => (
      <Box key={ci} sx={{ mb: 2 }}>
        <Skeleton variant="text" width={120} height={28} sx={{ mb: 1 }} />
        <List disablePadding>
          {Array.from({ length: ITEMS_PER_CATEGORY }).map((_, ii) => (
            <ListItem key={ii} disableGutters sx={{ py: 0.5 }}>
              <Skeleton variant="text" width="60%" height={24} />
              <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="circular" width={24} height={24} />
              </Box>
            </ListItem>
          ))}
        </List>
        <Skeleton variant="text" width={120} height={28} sx={{ mt: 1 }} />
      </Box>
    ))}
  </Box>
);
